<template>
  <div id="isLive">
    <eventSearch :live="1" place="Arama..." v-show="!filter.upcoming" />
    <ul class="top-filter" v-show="!filter.upcoming">
      <li>
        <input v-model="showOnlyFavorites" type="checkbox"/>
        <span><i class="fa fa-star-o"></i> Favorileri goster
          <a href="javascript:;" v-on:click="removeAllFav()" v-tooltip="'Tüm favorileri sil'" class="pull-right ml-4"><i class="os-icon os-icon-trash-2"></i></a></span>
      </li>

      <li class="right">
        <input type="checkbox" checked>
        <span><i class="os-icon os-icon-bar-chart-up"></i> Istatistikler</span>
      </li>

      <li class="right">
        <input type="checkbox" checked>
        <span><i class="os-icon os-icon-sliders"></i> Skorboardlar</span>
      </li>
    </ul>

    <sportToolbar onlive="1" v-show="!filter.upcoming" />

    <div v-if="eventNotfound" class="alert alert-info">
      {{ t.error.notfound_fixture }}
    </div>

    <div class="col-12 text-center">
      <spinalLoader class="mt-5" v-show="loader" />
    </div>

    <div class="event-list LiveBets" v-if="events">

      <template v-for="(l, inx) in events">
        <div v-if="inx > 0 && l.type === 'sport'" class="space_20 seperator"></div>

        <SportRow :sticky="sticky" :sport="l" :extendedMarkets="extendedMarkets" :onLive="onLive" v-if="l.type === 'sport' && !hideTitles"/>
        <CompetitionRow :competition="l" v-if="l.type === 'competition'" />
        <RegionRow :sticky="sticky" :region="l" :extendedMarkets="extendedMarkets" :onLive="onLive" v-if="l.type === 'region' && !hideTitles"/>
        <MatchRow class="r-event" v-if="l.type === 'event'" :match.sync="l" :sport="l.sport" :region="l.region" 
                  :extendedMarkets="extendedMarkets"
                  :indx="inx"
                  :i="inx"
                  :selectedOdds="selectedOdds"
                  :m="l.eid" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" />

        <div v-if="selectedMatch && selectedMatch.matchId == l.matchId" id="sr_widget" :class="'sr-widget-'+selectedMatch.rid"></div>
        <odd :live="(l.onLive) ? 1 : 0" :matchId="l.matchId" v-if="selectedMatch && selectedMatch.matchId == l.matchId"/>

      </template>
    </div>

  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import ContentPlaceholder from 'vue-content-placeholder'
import betSlip from '@/mixins/betSlip'
import BetSlipC from '@/components/sportsbook/BetSlip';
import odd from '@/components/sportsbook/odd';
import sportIcon from '@/components/ui/asset/sportIcon';
import MatchRow from '@/components/sportsbook/MatchRow'
import sportToolbar from '@/components/sportsbook/sportToolbar'
import favorites from '@/mixins/favorite'
import spinalLoader from '@/components/ui/loader/spinalLoader'
import SportRow from '@/components/sportsbook/SportRow'
import RegionRow from '@/components/sportsbook/RegionRow'
import eventSearch from '@/components/sportsbook/widget/eventSearch';

export default {
  name: 'LiveMatches',
  components: {eventSearch, Paginate, BetSlipC, odd, sportIcon, MatchRow, sportToolbar, spinalLoader, SportRow, RegionRow},
  mixins: [betSlip,favorites],
  props: {
    filter: {},
    onLive: false,
    extendedMarkets: {
      default: true
    },
    hideTitles: false,
    pp: 55,
    list: false
  },
  data() {
    return {
      previousStateRequest: null,
      previousRequest: null,
      xhr_request: [],
      activeEvents: [],
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
      },
      loader: null,
      t: this.$root.t,
      newevents: [],
      events: [],
      selectedOdds: [],
      eventNotfound: false,
      selectedEventDate: false,
      activeEventsKeys: [],
      activeEventMap: [],
      session: session,
      pagination: [],
      page: 1,
      changedOdd: [],
      odd: [],
      matchId: 0,
      matchName: null,
      selectedMatch: null,
      eventIds: null,
      upcoming: null,
      scrolled: false,
      lockMatchUpdate: false,
      sticky: true,
      placeholderRows: [

        {
          height: '1rem',
          boxes: [[0, '100%']]
        },

      ],
      showOnlyFavorites: false,
      favoriteList: [],
    }
  },
  watch: {
    'showOnlyFavorites'(v) {
      this.events = null;

      if(v && this.onLive > 0){
        this.$getItem('fav', (key, value) => {
          //console.log all the kay/value pairs

          this.$bus.$emit('ListOnlyFavorites', value);

        }, function (err) {

        })
      }

      if(!v)
        this.$bus.$emit('ListOnlyFavorites', null);
    },
    '$route.params'() {
      this.events = null;
      this.fetchEvents();
    },
    'filter'() {
      this.fetchEvents();
    },
    'matchId'(o, n) {

      if (n == 0) {

      }

      if (o) {
      }

    }
  },
  beforeDestroy() {
    clearInterval(this.EventInterval);
    clearInterval(this.EventInterval2);
    clearInterval(this.EventInterval3);

    this.abortAllRequest();
  },
  mounted() {

    var self = this;
    this.syncSelectedBets();

    clearInterval(this.EventInterval);

    if(this.filter.onLive){
      //clearInterval(this.EventInterval2);
      clearInterval(this.EventInterval3);
      this.EventInterval2 = setInterval(this.fetchLatestBets, 15000);
      this.EventInterval3 = setInterval(this.fixtureState, 3000);
    }

    this.EventInterval = setInterval(this.fetchEvents, 60000);

    this.fetchEvents();
    this.fetchSelectedBets();

    this.$bus.$on('openMatchOdd', (payload) => {

      if(this.selectedMatch){

        if(this.selectedMatch.eid !== payload.eid){
          this.selectedMatch = payload;
          this.sticky = false;
        }else if(this.selectedMatch.eid === payload.eid){
          this.selectedMatch = null;
          this.sticky = true;
        }

      }else{
        this.selectedMatch = payload;
        this.sticky = false;
      }

    });

    this.$bus.$on('selectedBets', ($event) => {

      this.$set(this, 'selectedOdds', $event);

    });

    this.$bus.$on('addFav', ($event) => {

      self.favoriteList = $event;

      if(self.showOnlyFavorites){
        self.events = null;

        setTimeout(() => {
          self.eventIds = $event;
          self.fetchEvents()
        }, 500)
      }

    });

    this.$bus.$on('removedAllFav', ($event) => {

      self.favoriteList = [];

      self.events = null;

      setTimeout(() => {
        self.eventIds = $event;
        self.fetchEvents()
      }, 500)

    });

    this.$bus.$on('FixtureEventSearch', ($event) => {

      self.eventIds = $event;

      self.fetchEvents()

    });

    this.$bus.$on('ListOnlyFavorites', ($event) => {

      self.eventIds = $event;

      if(!$event)
        self.eventIds = null;

      setTimeout(() => {

        if(this.filter.onLive){
          self.fetchEvents()
        }

      }, 500)

    });

  },
  methods: {
    syncSelectedBets (event = false) {
      this.$getItem('selectedBets', (key, value) => {

        this.selectedOdds = value;

        this.$set(this, 'selectedOdds', this.selectedOdds);
      });

    },
    showFavorites () {

    },
    onWaypoint({el, going, direction}) {
      // going: in, out
      // direction: top, right, bottom, left
        if (going === this.$waypointMap.GOING_IN) {
        //console.log('waypoint going in!');

        this.activeEvents.push(el.getAttribute('m'));
        this.activeEventsKeys.push(el.getAttribute('i'));
        //console.log(`#${el.getAttribute('m')}`)
        el.classList.toggle('active', this.$waypointMap.GOING_IN === going)
      }

      if (going === this.$waypointMap.GOING_OUT) {
        //console.log(direction)
        this.activeEvents.remByVal(el.getAttribute('m'))
        this.activeEventsKeys.remByVal(el.getAttribute('i'))
      }

      if (direction === this.$waypointMap.DIRECTION_TOP) {
        //console.log('waypoint going top!')
      }
    },
    onChangePage(page) {
      this.pagination.current = page;
      this.filter.page = page;

      var upc = this.$route.query.upcoming;
      this.$router.push({});

      this.$router.push({query: {page: page, upcoming: upc}});


      window.scroll(0, 0);
    },
    fixtureState () {
      this.$http.get(bsapi + 'api/v1/fixture/state/'+this.currentFixtureState, {
        before(request) {

          // abort previous request, if exists
          if (this.previousStateRequest) {
            this.previousStateRequest.abort();

          }

          // set previous request on Vue instance
          this.previousStateRequest = request;
          this.xhr_request.push(request);
        }
      }).then(response => {
        // get body data

        if(response.body)

        Object.values(response.body).forEach((v) => {

          this.currentFixtureState = v.state;

          let findEvent = false;

          if(this.events)
            findEvent = this.events.find(o => o.eid === v.eventId);

          if(findEvent){

            let ress = this.events.indexOf(findEvent);

            if(v.command === 'update_market' || v.command === 'insert_market' || v.command === 'insert_market')
              this.events[ress].odds[v.dataId] = v.data;

            if(v.command === 'remove_market')
              delete this.events[ress].odds[v.dataId];

            if(v.command === 'update_match'){

              if(typeof this.events[ress] !== 'undefined'){
                v.data.odds = this.events[ress].odds;
                this.events[ress] = v.data;
                this.events[ress].data = v.data.data;
                this.$set(this.events, ress, v.data);
              }else {

                this.events.push(v.data);
                this.$set(this, 'events', v.data);
              }

              //console.log(findEvent.name);
              //console.log(v.data);

            }


            if(v.command === 'suspend_match'){
              this.events[ress].isSuspended = true;
            }



            //this.$set(this.events, ress, findEvent);

            //console.log(findEvent.name);
            //console.log(v.eventId + ' - '+v.data.market.name );
            //console.log(v.data);
            //console.log(this.events[ress].odds[v.dataId]);


            //let ress = this.events.indexOf(findEvent);
            //this.$set(this.events, ress, d);
          }

          //this.$bus.$emit('fixture_state_'+v.eventId, v);
        });


      }, response => {


      })
    },
    abortAllRequest () {
        this.xhr_request.forEach((r,v) => {
          r.abort();
        })
    },
    fetchLatestBets() {
      //th.$bus.$emit('updatedOdd', payload);

      if(!this.lockMatchUpdate){

        this.$http.get(bsapi + 'matches.aspx', {
          params: {
            match: this.activeEvents,
            app: this.$root.app.id,
            uid: this.$root.session.uid,
            onLive: 1,
            onlyList: 1
          }
        }).then(response => {
          // get body data
          if (response.body) {
            /*
            response.body.forEach(data => {
              this.$bus.$emit('updatedOdd', data);
            }); */

            response.body.result.forEach((d,k) => {

              let findEvent = this.events.find(o => o.eid === d.eid);
              let ress = this.events.indexOf(findEvent);
              this.$set(this.events, ress, d);
            });

            this.syncSelectionClass();

          }

        }, response => {

        })
      }
    },
    fetchEvents() {

      if(window.windowLiveCache && this.filter.isLive)
        this.events = window.windowLiveCache;

      if(window.windowFocused > 0){
        this.eventNotfound = false;
        this.lockMatchUpdate = true;

        //this.$bus.$emit('globalLoader', 1);
        this.loader = (this.loader === null) ? true : false;
        this.$http.get(bsapi + 'matches.aspx', {
          params: {
            per_page: (this.filter.per_page) ? this.filter.per_page : 200,
            sport: (this.$route.params.sport) ? [this.$route.params.sport] : [this.filter.sport],
            region: (this.$route.params.region) ? [this.$route.params.region] : null,
            competition: (this.$route.params.competition) ? [this.$route.params.competition] : null,
            page: this.$route.query.page,
            withBets: null,
            upcoming: (this.$route.query.upcoming) ? this.$route.query.upcoming : this.filter.upcoming,
            match: this.eventIds,
            onLive: (this.onLive) ? 1 : '',
            isLive: (this.filter.isLive) ? 1 : '',
            app: this.$root.app.id,
            uid: this.$root.session.uid,
            onlyList: 'row',
            listFavourites: this.listFavourites,
            t: (this.filter.onLive) ? Math.floor(Date.now() / 1000) : null
          },
          before(request) {

            // abort previous request, if exists
            if (this.previousRequest) {
              this.previousRequest.abort();
            }

            // set previous request on Vue instance
            this.previousRequest = request;
            this.xhr_request.push(request);
          }

        }).then(response => {
          // get body data

          this.syncSelectionClass();

          if(!this.scrolled) {
            setTimeout(() => {
              window.scrollTo(0, 1);
            }, 500);
            this.scrolled = true;
          }

          if(response.body.result.sport){
            this.events = Object.values(response.body.result.sport);
          }else {
            window.windowLiveCache = response.body.result;
            this.events = response.body.result;
          }

          this.syncSelectedBets();

          this.pagination = response.body.pagination;
          this.loader = false;
          this.eventNotfound = false;
          this.lockMatchUpdate = false;
          //this.$bus.$emit('globalLoader', 0);

        }, response => {
          // error callback
          this.loader = false;
          this.pagination = false;
          //this.$bus.$emit('globalLoader', 0);
        })
      }else {
        this.loader = false;
      }
    },
    fetchSelectedBets() {
      this.$getItem('bets', function (key, value) {
        ////console.log all the kay/value pairs

        self.selectedOdds = value;

      }, function (err) {
        self.updateBets([])
      })
    },
    closeOdd() {
    },
    updateOdd(odd) {
      var change;

      change = null;

      if (this.changedOdd.id == odd.id) {
        change = (odd.odd > this.changedOdd.n) ? 'down' : 'up';
        odd.odd = this.changedOdd.n;
      }

      return change;
    },
    toggleMatch(match) {
      match.toggle = (match.toggle) ? false : true;
      //console.log(match.toggle);
    },
    getSportIco(vb) {
      //console.log(this.sportEmoji);
      return this.sportEmoji[vb];
    },
    totalShorts(outcome) {
      return (outcome == 'Over') ? '+' : '-';
    },
    checkSport(sportId) {
      if (this.$route.params.sport == 0) {
        return true;
      } else if (!this.$route.params.sport) {
        return true;
      } else {
        return (sportId == this.$route.params.sport) ? true : false;
      }
    },
    fixEvents(e) {
      var matches = new Array();
      this.sortAByKey(e, 'order').forEach((k, ev) => {

        if(typeof k.matches !== 'undefined'){
          Object.values(k.matches).forEach((m, mk) => {
            matches.push(m);
          });
        }

      });

      return matches;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .top-filter {
    float: left;
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .top-filter li{
    float: left;
    list-style: none;
    font-size: 11px;
    line-height: 15px;
    background: rgba(0, 0, 0, 0.07);
    padding: 8px 20px;
    display: inline-block;
  }
  .top-filter li.right{
    float: right;
  }
  .top-filter li input{
    float: left;
    margin-right: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/LiveMatches.vue